export type VideoQuality = "low" | "medium" | "high" | "very-high";

export const getMediaConstraints = (quality: VideoQuality): MediaStreamConstraints => {
  let targetHeight = 480;
  let targetWidth = 854;
  let targetFrameRate = 20;
  if (quality === "low") {
    targetHeight = 360;
    targetWidth = 640;
    targetFrameRate = 20;
  } else if (quality === "medium") {
    targetHeight = 480;
    targetWidth = 854;
    targetFrameRate = 20;
  } else if (quality === "high") {
    targetHeight = 720;
    targetWidth = 1280;
    targetFrameRate = 20;
  } else if (quality === "very-high") {
    targetHeight = 1080;
    targetWidth = 1920;
    targetFrameRate = 30;
  }
  return {
    video: {
      width: { ideal: targetWidth },
      height: { ideal: targetHeight },
      advanced: [
        { frameRate: { min: targetFrameRate } },
        { height: { min: targetHeight } },
        { width: { min: targetWidth } },
        { frameRate: { max: targetFrameRate } },
        { width: { max: targetWidth } },
        { height: { max: targetHeight } },
        { aspectRatio: { exact: 1.77778 } },
      ],
    },
    audio: { 
      echoCancellation: { ideal: true }, 
      autoGainControl: { ideal: true }, 
      noiseSuppression: { ideal: true }
     },
  };
};

const DEFAULT_VIDEO_PARAMS_SCREEN = {
  audio: {
    maxBitrate: 64_000,
  },
  video: {
    maxBitrate: 1_500_000,
    maxFramerate: 20,
  },
};
export const DEFAULT_VIDEO_PARAMS = {
  pedagogy: {
    webcam: {
      audio: {
        maxBitrate: 64_000,
      },
      video: {
        maxBitrate: 1_000_000,
        maxFramerate: 20,
      },
    },
    screensharing: DEFAULT_VIDEO_PARAMS_SCREEN,
  },
  student: {
    webcam: {
      audio: {
        maxBitrate: 40_000,
      },
      video: {
        maxBitrate: 750_000,
        maxFramerate: 20,
      },
    },
    screensharing: DEFAULT_VIDEO_PARAMS_SCREEN,
  },
  expert: {
    camera: {
      audio: {
        maxBitrate: 64_000,
      },
      video: {
        maxBitrate: 2_500_000,
        maxFramerate: 30,
      },
    },
    webcam: {
      audio: {
        maxBitrate: 64_000,
      },
      video: {
        maxBitrate: 2_500_000,
        maxFramerate: 30,
      },
    },
    screen: DEFAULT_VIDEO_PARAMS_SCREEN,
  },
} as const;
